import React from 'react';

export const BlankLayout: React.FC<any> = props => {
  return <>{props.children}</>;
};

export default BlankLayout;
